import Operation from './Operation';

export default function SetG5xOffset(props) {
  return (<Operation {...props}>
  SetG5xOffset
  </Operation>);
};
